/* remove-non-us-elements */
const isUS = window.Shopify.country === 'US';
const isCA = window.Shopify.country === 'CA';
const themeInit = () => {
  if (isUS) {
    // Hiding the elements prevents non-US customers from seeing a flash
    document.getElementById('USOnly').remove();
    document.getElementById('USAndCAOnly').remove();
  } else if (isCA) {
    document.getElementById('USAndCAOnly').remove();
  } else {
    document.querySelectorAll('[data-us-only], [data-us-and-ca-only]').forEach((element) => {
      element.remove();
    });
  }
};
document.addEventListener('DOMContentLoaded', () => {
  themeInit();
});

/* shopify-challenge */
const REDIRECT_PATH = '/account';
const shopifyChallengeSelector = '.shopify-challenge__container form';
const shopifyChallengeForm = document.querySelector(shopifyChallengeSelector);
let redirectInput = document.createElement('input');
if (shopifyChallengeForm) {
  redirectInput.setAttribute('name', 'return_to');
  redirectInput.setAttribute('type', 'hidden');
  redirectInput.value = REDIRECT_PATH;
}

/* focusStateController */
const preventFocusStates = () => {
  document.body.classList.add('using-mouse');
  document.body.classList.remove('using-tab-key');
  // remove the mouse event listener but add back the tab listener in case the user switches
  document.body.removeEventListener('mousedown', preventFocusStates);
  document.body.addEventListener('keydown', enableFocusStates);
};
const enableFocusStates = (event) => {
  // 9 === tab key
  if (event.keyCode === 9) {
    document.body.classList.remove('using-mouse');
    document.body.classList.add('using-tab-key');
    // remove the tab event listener but add back the mouse listener in case the user switches
    document.body.removeEventListener('keydown', enableFocusStates);
    document.body.addEventListener('mousedown', preventFocusStates);
  }
};
